import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=086b1906&scoped=true&"
import script from "./ProductEdit.vue?vue&type=script&lang=js&"
export * from "./ProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductEdit.vue?vue&type=style&index=0&id=086b1906&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086b1906",
  null
  
)

export default component.exports